module.exports = __webpack_public_path__ + "static/media/curve-1-flipped.5cc75aa9.svg";